// Exports
export default {
	"fullscreenButton": "fullscreenButton_N8X2N",
	"fullscreenButtonPinned": "fullscreenButtonPinned_kBnLR"
};
